import css from './sass/block.sass';
import 'slick-carousel';

if (typeof wp !== 'undefined') {
    wp.domReady(function () {
        // Remove unused blocks
        wp.blocks.unregisterBlockType('core/latest-posts');
        wp.blocks.unregisterBlockType('core/gallery');

        wp.blocks.unregisterBlockStyle('core/button', 'default');
        wp.blocks.unregisterBlockStyle('core/button', 'outline');
        wp.blocks.unregisterBlockStyle('core/button', 'squared');
        wp.blocks.unregisterBlockStyle('core/button', 'fill');

        wp.blocks.registerBlockStyle( 'core/button', {
            name: 'btn-primary',
            label: 'Plein',
            isDefault: true
        } );

        wp.blocks.registerBlockStyle( 'core/image', {
            name: 'gray-layer',
            label: 'Assombrie',
            isDefault: false,
        });
    });
}

jQuery(function($) {
    function loadBlocks() {
        // Block click event in back office to prevent non desired actions
        if( $('.wp-admin .block-g').length > 0 ) {
            $('.wp-admin .block-g').on('click', function(e) {
                e.preventDefault();
            });
        }

        $('.slide-n-1').not('.slick-initialized').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            autoplay: true,
            autoplaySpeed: 2000
        });

        $('.slide-n-3').not('.slick-initialized').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 0,
            autoplay: false,
            autoplaySpeed: 2000
        });

        $('.block-brands-slider .slideshow').not('.slick-initialized').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            rows: 0,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });

        $('.block-testimonials .slideshow').not('.slick-initialized').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            rows: 0,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    }

    if( window.acf ) {
        window.acf.addAction( 'render_block_preview', loadBlocks );
    } else {
        window.onload=loadBlocks();
    }
});